import { useContext } from 'react';
import { ToggleContext } from '~/toggles/toggleContext';
import { ToggleDecisions } from '~/toggles/toggleDecisions';

export function useToggles() {
    const toggleRouter = useContext(ToggleContext);
    return new ToggleDecisions(toggleRouter);
}
